.results-page {
  min-height: 100svh;
}

.results-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

/* Tabs */
.results-tabs {
  display: flex;
  gap: 1rem;
  padding: 1rem;
  border-radius: 12px;
  overflow-x: auto;
  white-space: nowrap;
}

.result-tab {
  padding: 0.75rem 1.5rem;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: var(--text-secondary);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.result-tab:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

.result-tab.active {
  background: var(--primary);
  color: var(--bg-base);
  border-color: var(--primary);
  box-shadow: 0 0 15px rgba(0, 229, 255, 0.3);
}

/* Trophy Banner */
.trophy-banner {
  display: flex;
  align-items: center;
  gap: 2rem;
  padding: 2rem 3rem;
  margin-bottom: 2rem;
  background: linear-gradient(135deg, rgba(250, 204, 21, 0.1) 0%, rgba(0, 0, 0, 0.5) 100%);
  border: 1px solid rgba(250, 204, 21, 0.3);
  position: relative;
  overflow: hidden;
}

.premium-glow::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(250, 204, 21, 0.1) 0%, transparent 60%);
  animation: rotate 10s linear infinite;
  z-index: 0;
  pointer-events: none;
}

.trophy-icon-wrapper {
  position: relative;
  z-index: 1;
  background: rgba(0, 0, 0, 0.5);
  padding: 1.5rem;
  border-radius: 50%;
  border: 1px solid rgba(250, 204, 21, 0.5);
  box-shadow: 0 0 30px rgba(250, 204, 21, 0.2);
}

.trophy-text {
  position: relative;
  z-index: 1;
}

/* Podium Layout */
.podium-section {
  padding: 3rem 2rem;
  margin-bottom: 2rem;
}

.podium-display {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 1rem;
  min-height: 400px;
  padding-top: 2rem;
}

.podium-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  max-width: 300px;
  position: relative;
}

.podium-avatar {
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  z-index: 2;
}

.gold-glow {
  width: 100px;
  height: 100px;
  border: 2px solid #facc15;
  box-shadow: 0 0 40px rgba(250, 204, 21, 0.4);
}

.silver-glow {
  width: 80px;
  height: 80px;
  border: 2px solid #d1d5db;
  box-shadow: 0 0 30px rgba(209, 213, 219, 0.3);
}

.bronze-glow {
  width: 80px;
  height: 80px;
  border: 2px solid #d97706;
  box-shadow: 0 0 30px rgba(217, 119, 6, 0.3);
}

.podium-details {
  text-align: center;
  margin-bottom: 1rem;
  z-index: 2;
  padding: 0 10px;
}

.winner-name {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 0.25rem;
}

.winner-school {
  font-size: 0.85rem;
  color: var(--text-secondary);
  margin-bottom: 0.5rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.winner-score {
  font-family: monospace;
  font-weight: bold;
  background: rgba(255, 255, 255, 0.1);
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
}

.podium-block {
  width: 100%;
  text-align: center;
  font-weight: 800;
  font-size: 1.5rem;
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
}

.podium-block::after {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0; height: 2px;
}

.block-1 {
  height: 200px;
  background: linear-gradient(to top, rgba(250, 204, 21, 0.05), rgba(250, 204, 21, 0.2));
  border: 1px solid rgba(250, 204, 21, 0.3);
  border-bottom: none;
}
.block-1::after { background: #facc15; }

.block-2 {
  height: 150px;
  background: linear-gradient(to top, rgba(209, 213, 219, 0.05), rgba(209, 213, 219, 0.2));
  border: 1px solid rgba(209, 213, 219, 0.3);
  border-bottom: none;
}
.block-2::after { background: #d1d5db; }

.block-3 {
  height: 100px;
  background: linear-gradient(to top, rgba(217, 119, 6, 0.05), rgba(217, 119, 6, 0.2));
  border: 1px solid rgba(217, 119, 6, 0.3);
  border-bottom: none;
}
.block-3::after { background: #d97706; }

/* Table */
.consolation-section {
  padding: 2rem;
}

.table-responsive {
  overflow-x: auto;
}

.results-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}

.results-table th {
  text-align: left;
  padding: 1rem;
  color: var(--text-secondary);
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 1px;
}

.results-table th.text-right {
  text-align: right;
}

.results-table td {
  padding: 1rem;
  background: var(--input-bg);
  border-top: var(--glass-border);
  border-bottom: var(--glass-border);
}

.results-table tr td:first-child {
  border-left: var(--glass-border);
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.results-table tr td:last-child {
  border-right: var(--glass-border);
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.results-table tr:hover td {
  background: var(--bg-card);
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@media (max-width: 768px) {
  .trophy-banner {
    flex-direction: column;
    text-align: center;
    padding: 2rem 1.5rem;
  }
  
  .podium-display {
    align-items: flex-start;
    flex-direction: column;
    gap: 2rem;
  }
  
  .podium-step {
    max-width: 100%;
    flex-direction: row;
    align-items: center;
    text-align: left;
    width: 100%;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 12px;
    padding: 1rem;
    border: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  .podium-avatar {
    margin-bottom: 0;
    margin-right: 1.5rem;
  }
  
  .podium-details {
    text-align: left;
    margin-bottom: 0;
    flex: 1;
  }
  
  .podium-block {
    display: none;
  }
  
  /* Order for mobile: Gold, Silver, Bronze */
  .step-1 { order: 1; border-color: rgba(250, 204, 21, 0.4); }
  .step-2 { order: 2; }
  .step-3 { order: 3; }
}
